import { atom, selector } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";

export const mapPerspectiveState = atom({
  key: 'mapPerspectiveState',
  default: selector({
    key: 'mapPerspectiveStateSelector',
    get: () => {
      return getCustomerSettings('mapPerspective');
    }
  })
});